import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/noData.png'


const _withScopeId = n => (_pushScopeId("data-v-012f2573"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrap"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "isNoData"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "还没有收货地址，去添加一个吧", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "showAddressData"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "nameOrphone" }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = { class: "action" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("设为默认")
const _hoisted_13 = { class: "actionBtn" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("新增收货地址")

import { NavBar, Search, Checkbox, Button, Toast } from "vant";
import CreateAddress from "@/components/CreateAddress.vue";
import { ref } from "vue";
import { request } from "@/provide/fetch";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  name: 'Address',
  props: {
  type: {
    type: String,
  },
},
  emits: ["change"],
  setup(__props, { emit }) {

const props = __props



const addressList = ref([]);
const createVisible = ref(false);
const handleAddSave = () => {
  createVisible.value = false;
  handlegetPage();
};
const handleAddCancel = () => {
  createVisible.value = false;
  handlegetPage();
};
const handlegetPage = async () => {
  const res = await request({
    url: "/order/address/page",
    method: "POST",
    data: { searchOption: {}, pageParam: { current: 1, size: 100 } },
  }).catch(() => {
    Toast("网络错误，请稍后重试");
  });
  if (res.code === 200) {
    addressList.value = res.data.records;
  } else {
    Toast(res.message);
  }
};
handlegetPage();
const handleListClick = () => {
  if (props.type === "submitOrder") {
    emit("change");
  } else {
    router.go(-1);
  }
};
const handleItemClick = (item: any) => {
  emit("select", item);
};
const editId = ref(null);
const handleEdit = (item: any) => {
  editId.value = item.addressId;
  createVisible.value = true;
};
const handleUpload = (item) => {
  request({
    url: "/order/address/save-or-update",
    method: "POST",
    data: {
      addressId: item.addressId,
      isDefault: item.isDefault ? 1 : 0,
      userName: item.userName,
      phone: item.phone,
      province: item.province,
      city: item.city,
      country: item.country,
      detailAddress: item.detailAddress,
    },
  })
    .then((res) => {
      if (res.code === 200) {
        handlegetPage();
      } else {
        handlegetPage();
        Toast(res.message);
      }
    })
    .catch(() => {
      handlegetPage();
      Toast("网络错误，请稍后重试");
    });
};
const handleDelete = (item: any) => {
  request({
    url: `/order/address/delete/${item.addressId}`,
    method: "POST",
  })
    .then((res) => {
      handlegetPage();
      if (res.code === 200) {
        Toast.success("成功");
      } else {
        Toast.success(res.message);
      }
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!createVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(NavBar), {
            title: "收货地址",
            "left-arrow": "",
            onClickLeft: handleListClick
          }),
          _createElementVNode("div", _hoisted_2, [
            (!addressList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "addressItem",
                      onClick: ($event: any) => (handleItemClick(item))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(item.userName), 1),
                        _createElementVNode("span", null, _toDisplayString(item.phone), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item.province) + " " + _toDisplayString(item.city) + " " + _toDisplayString(item.country) + " " + _toDisplayString(item.detailAddress), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_unref(Checkbox), {
                          "icon-size": "12px",
                          onClick: _withModifiers(($event: any) => (handleUpload(item)), ["stop"]),
                          modelValue: item.isDefault,
                          "onUpdate:modelValue": ($event: any) => ((item.isDefault) = $event),
                          shape: "square"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", {
                            onClick: _withModifiers(($event: any) => (handleDelete(item)), ["stop"])
                          }, "删除", 8, _hoisted_14),
                          _createElementVNode("span", {
                            onClick: _withModifiers(($event: any) => (handleEdit(item)), ["stop"])
                          }, "修改", 8, _hoisted_15)
                        ])
                      ])
                    ], 8, _hoisted_8))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(Button), {
              class: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
          createVisible.value = true;
          editId.value = null;
        })
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (createVisible.value)
      ? (_openBlock(), _createBlock(CreateAddress, {
          key: 1,
          onChange: handleAddSave,
          onCancel: handleAddCancel,
          editId: editId.value
        }, null, 8, ["editId"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})